import * as React from "react"
// helper
import { ISvgIcons } from "./helper"

export const HamburgerMenuIcon: React.FC<ISvgIcons> = ({
    className = "",
    ...rest
}) => (
    <svg
        viewBox="0 0 32 32"
        className={`${className}`}
        stroke="currentColor"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        strokeWidth="1.5"
        strokeLinecap="round"
        {...rest}
    >
        <path d="M4 9.33301H28" stroke="#292D32" />
        <path d="M4 16H28" stroke="#292D32" />
        <path d="M4 22.667H28" stroke="#292D32" />
    </svg>
)
